module.exports = __webpack_public_path__ + "img/0S6A9654-min.cbd5ccb9.jpg";